import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import Label from "../Label";
import markerCss from '../Marker.module.css';
import labelCss from '../Label.module.css';
import {getPokemonIcon, getSecsLeft} from "../../../utils";
import css from './RaidMarker.module.css';
import {pokemonIsWeatherBoosted} from "../../../utils/weatherBoost";

const RaidMarker = (props) => {
	const [secsLeft, setSecsLeft] = useState(getSecsLeft(props.raid.end));
	const timer = useRef(false);

	useEffect(() => {
		const secsUntilRefresh = secsLeft % 60 + 1;
		if( secsLeft > 0 )
			timer.current = setTimeout(() => {setSecsLeft(getSecsLeft(props.raid.end))}, secsUntilRefresh*1000);
		// console.log("Timer for " + props.raid.gym_name, timer.current);
		// eslint-disable-next-line
	}, [secsLeft]);

	useEffect(() => {
		return () => {
			// console.log("Unmounting " + props.raid.gym_name, timer.current);
			if( timer.current )
				clearTimeout(timer.current);
		}		// eslint-disable-next-line
	}, []);

	if( secsLeft <= 0 )
		return null;

	const secsToStart = getSecsLeft(props.raid.start);

	const getIcon = () => {
		if( props.raid.pokemon_id )
			return <img style={{height: 40}} alt='Raid' className={css.RaidIconPokemon} src={getPokemonIcon(props.raid.pokemon_id)} />;

		return <img alt='Raid' className={css.RaidIconEgg} src={'img/raidEggs/raid-level-' + props.raid.level + '.png'} />;
	};

	const icon = getIcon();
	const isWeatherBoosted = pokemonIsWeatherBoosted(props.raid.pokemon_id, props.raid['s2-10']);
	const label = [];
	if( props.raid.level === 6 && props.raid.pokemon_id )
		label.push(<div><i>Mega</i></div>);
	if( isWeatherBoosted )
		label.push(<img alt='Weather Boost' height='16' className={css.WeatherBoostIcon} src={'https://www.a2pogo.com/common/images/pokemon/weather/weather-' + isWeatherBoosted + '.png'} />);

	if(secsToStart < 0)
		label.push(Math.floor(secsLeft/60) + "m left");
	else
		label.push('In ' + Math.floor(secsToStart/60) + "m");

	return (<>
	{props.infoWindow}
	<div className={markerCss.Marker} >

		<div onClick={() => props.onClick(props.raid)}>
			{icon}
		</div>

		<Label classes={[secsToStart < 0 ? labelCss.LabelRaidActive : labelCss.LabelRaidWaiting]} text={label}/>
	</div></>);
};

RaidMarker.propTypes = {
	raid: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired
};

export default RaidMarker;